export { default } from '@framework/tenant/config/condor';
